<template>
    <div class="border-b border-gray-400 pt-8 pb-2">
        <form-row title="Office" :no_border="true" class="mb-6">
            <div class="sm:col-gap-2 flex-1 -mt-2 sm:-mt-4">
                <input-text
                    label="Office Name"
                    name="office_name"
                    :value="settings.office_name"
                    placeholder="Name"
                />
            </div>

            <div class="sm:col-gap-2 flex-1 mt-2 sm:-mt-4">
                <input-text
                    label="Office ID"
                    name="office_id"
                    :value="settings.office_id"
                    placeholder="#"
                />
            </div>
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        settings: { default: () => ({}) },
    },
}
</script>
